import axios from 'axios';

const API_KEY = '9b43b879f97da484cfeec869ba43';
const BASE_URL = `/scheduling_api/${window.gon.shoploader_org_id}`;

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  headers: {
    'Authorization': `Bearer ${API_KEY}`,
    'Content-Type': 'application/json',
  }
});

export default api;
